export const TOGGLE_MODAL_GENERAL_ERROR = 'TOGGLE_MODAL_GENERAL_ERROR';

export function toggleModalGeneralError(message = null) {
  return {
    type: TOGGLE_MODAL_GENERAL_ERROR,
    message,
  };
}
